import { type ReactNode } from 'react';
import '@common/styles/components/list.pcss';

interface SimpleListProps {
  children: ReactNode;
}

function SimpleList({
  children,
}: Readonly<SimpleListProps>) {
  return (
    <ul className="list">
      {children}
    </ul>
  );
}

export default SimpleList;
